import React, { createContext, ComponentType, FC } from 'react';
import { useCurrentUser, useClient } from 'hooks';

export interface IWithFeatures {
  features: {
    leaderboard: boolean;
    video: boolean;
  };
}

// @ts-ignore
const EVERYONESOCIAL_CLIENT_IDS = [
  '6b2fd329-61d4-489d-82c5-5a1fb36b1895', // staging
  'cf797056-44d6-4b90-982b-228a162b4c1b', // prod
  'fbaa08da-2ca2-45e9-9d82-d8bf7869f70d', // QA
];

const FeaturesContext = createContext<IWithFeatures>({
  features: {
    leaderboard: false,
    video: false,
  },
});

const FeaturesProvider: FC = ({ children }) => {
  const { id } = useClient();
  const { leaderboard_enabled } = useCurrentUser();
  const features = {
    leaderboard: leaderboard_enabled,
    video: EVERYONESOCIAL_CLIENT_IDS.includes(id),
  };

  return <FeaturesContext.Provider value={{ features }}>{children}</FeaturesContext.Provider>;
};

const withFeatures = <T extends {}>(Component: ComponentType<T>) => (props: T) => (
  <FeaturesContext.Consumer>
    {(providerProps: IWithFeatures) => <Component {...props} {...providerProps} />}
  </FeaturesContext.Consumer>
);

export { FeaturesContext, FeaturesProvider, withFeatures };
